import { render, staticRenderFns } from "./PersistTipoVeiculoView.vue?vue&type=template&id=2c5f9082&"
import script from "./PersistTipoVeiculoView.vue?vue&type=script&lang=ts&"
export * from "./PersistTipoVeiculoView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports